const choices = {
    yearly: 'annuelle',
    quarterly: 'trimestrielle',
    monthly: 'mensuelle',
};

export default choices;
